import styled from "styled-components/macro";
import { ChevronRight } from "@material-ui/icons";

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FieldLeftWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NameTypeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1em;
`;

export const PropertyWrapper = styled.div`
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

export const PropertyName = styled.div`
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  margin-right: 1em;
  color: #5f6368;
`;

export const StyledChevronRight = styled(ChevronRight)`
  && {
    color: #005aa9;
  }
`;
